import useSWR from "swr";
import fetcher from "../../utils/fetcher";
import ProductImage from "../ProductImage";
import HomeCarousel from "./HomeCarousel";
import styles from "../../styles/home.module.css";

// Shown only until the admin adds real photos from the dashboard
const PLACEHOLDER_HOMES = [
  "وَتَوَكَّلْ عَلَى الْحَيِّ",
  "فَاذْكُرُونِي أَذْكُرْكُمْ",
  "وَقُل رَّبِّ زِدْنِي عِلْمًا",
  "رَبِّ اشْرَحْ لِي صَدْرِي",
  "إِنَّ مَعَ الْعُسْرِ يُسْرًا",
];

const CustomerHomesSection = () => {
  const { data } = useSWR(`${process.env.REACT_APP_BACKEND_URL}/api/customer-homes`, fetcher, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
    dedupingInterval: 10000,
  });

  const homes = Array.isArray(data) ? data : [];

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>في بيوت عملائنا</h2>

      <HomeCarousel>
        {homes.length > 0
          ? homes.map((home) => (
              <div key={home.id} className={styles.homeCard}>
                <div className={styles.homeCardImg}>
                  <ProductImage url={home.imageUrl} alt={home.caption || "في بيوت عملائنا"} loading="lazy" />
                  {home.caption && <span className={styles.homeCaption}>{home.caption}</span>}
                </div>
              </div>
            ))
          : PLACEHOLDER_HOMES.map((text, i) => (
              <div key={i} className={styles.homeCard}>
                <div className={styles.homeCardImg}>
                  <div className={styles.cardFrame} style={{ width: "70%", aspectRatio: "21 / 9" }}>
                    <span className={styles.calligraphy}>{text}</span>
                  </div>
                </div>
              </div>
            ))}
      </HomeCarousel>
    </section>
  );
};

export default CustomerHomesSection;
